<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('ELEMENT_NAMEs')"
      :columns="columns"
      :column_search="true"
      resource_url="/ELEMENT_NAME/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <ELEMENT_NAME-modal ref="ELEMENT_NAME_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
} from "@/utils";
import CAPTIAL_ELEMENT_NAMEModal from "./ELEMENT_NAME_modal/Index.vue";

export default {
  name: "CAPTIAL_ELEMENT_NAMEsDatatable",
  components: { GenericTable, CAPTIAL_ELEMENT_NAMEModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("data"),
          name: "data",
          searchable: true,
          width: "80%",
          data: (row) => {
            return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            // return row.name || "";
          },
        },
        {
          title: v.$t("options"),
          width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.ELEMENT_NAME_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete ELEMENT_NAME?"),
                    v,
                    () => {
                      del("/ELEMENT_NAME", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.ELEMENT_NAME_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
